/* eslint-disable array-element-newline */
/* eslint-disable react/no-multi-comp */
/* eslint-disable react/jsx-no-bind */
import React, {useEffect, useState} from "react";
import AddressInfoForm from "./AddressInfoForm";
import PropTypes from "prop-types";
import VerificationContainer from "./VerificationContainer";

const AddressInfoContainer = ({
  addressInfo,
  enable2024Legal,
  modalRef,
  setAddressInfo,
  setBillingInfo,
  setDisplayErrors,
  setError,
  setIsEditingAddress,
  setSmsOptIn,
  smsOptIn
}) => {
  const [addresses, setAddresses] = useState(null);
  const [verificationStep, setVerificationStep] = useState(false);


  useEffect(() => {
    if (modalRef.current) {
      modalRef.current.scrollTop = 0;
    }
  }, [verificationStep]);

  return (
    <div className="address-info-container">
      {!verificationStep &&
        <AddressInfoForm
          addressInfo={addressInfo}
          addresses={addresses}
          enable2024Legal={enable2024Legal}
          setAddressInfo={setAddressInfo}
          setAddresses={setAddresses}
          setDisplayErrors={setDisplayErrors}
          setError={setError}
          setIsEditingAddress={setIsEditingAddress}
          setSmsOptIn={setSmsOptIn}
          setVerificationStep={setVerificationStep}
          smsOptIn={smsOptIn}
        />
      }
      {verificationStep &&
        <VerificationContainer
          addressInfo={addressInfo}
          addresses={addresses}
          setAddressInfo={setAddressInfo}
          setBillingInfo={setBillingInfo}
          setIsEditingAddress={setIsEditingAddress}
          setVerificationStep={setVerificationStep}
        />}

    </div>
  );
};

AddressInfoContainer.propTypes = {
  "addressInfo": PropTypes.object.isRequired,
  "enable2024Legal": PropTypes.bool.isRequired,
  "modalRef": PropTypes.object,
  "setAddressInfo": PropTypes.func.isRequired,
  "setBillingInfo": PropTypes.func.isRequired,
  "setDisplayErrors": PropTypes.func.isRequired,
  "setError": PropTypes.func.isRequired,
  "setIsEditingAddress": PropTypes.func.isRequired,
  "setSmsOptIn": PropTypes.func.isRequired,
  "shippingAddress": PropTypes.object,
  "smsOptIn": PropTypes.bool.isRequired
};

AddressInfoContainer.defaultProps = {
  "modalRef": null,
  "shippingAddress": {}
};

export default AddressInfoContainer;
